import { Box, Grid, GridColumn, Typography } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import classes from './InfoBanner.module.css.mjs';

const InfoBanner = ({ content }) => {
  const { message } = content;
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.infoBanner, "kohler-info-banner-root") }, /* @__PURE__ */ React.createElement(Grid, null, /* @__PURE__ */ React.createElement(GridColumn, { className: classes.infoBannerContent }, /* @__PURE__ */ React.createElement(Typography, { textTransform: "uppercase", size: "caption-s", component: "div" }, message))));
};

export { InfoBanner };
